/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import { genreSentimentSchema, type IGenreSentiment } from '../genre-sentiment-schema';
import { type IMovieRatingTotals, movieRatingTotalsSchema } from '../movie-rating-totals-schema';

const topMovieSchema = z.object({
  collectionId: z.number(),
  title: z.string(),
  slug: z.string(),
  genre: z.string().nullable(),
  loved: z.number(),
  liked: z.number(),
  disliked: z.number(),
  likeRate: z.number(),
});

export interface ITopMovie {
  collectionId: number;
  title: string;
  slug: string;
  genre: string | null;
  loved: number;
  liked: number;
  disliked: number;
  likeRate: number;
}

const movieRatingInsightsDataSchema = z.object({
  genres: z.array(genreSentimentSchema),
  topMovies: z.array(topMovieSchema),
  totals: movieRatingTotalsSchema,
  minRatings: z.number(),
});

export interface IMovieRatingInsightsData {
  genres: IGenreSentiment[];
  topMovies: ITopMovie[];
  totals: IMovieRatingTotals;
  minRatings: number;
}

export const getMovieRatingInsightsV1ResponseSchema = createApiResponseSchema(
  movieRatingInsightsDataSchema,
) as z.ZodSchema<IAPI<IMovieRatingInsightsData>>;

export type IGetMovieRatingInsightsV1Response = IAPI<IMovieRatingInsightsData>;
